import { useEffect, useMemo, useState } from "react";
import { BarChart3 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { Checkbox } from "./ui/checkbox";
import { Button } from "./ui/button";
import { aggregate } from "../lib/calc";

const money = (n) => n.toLocaleString("es-MX", { style: "currency", currency: "MXN" });

export default function ObrasReportDialog({ open, onOpenChange, entries, onDownload }) {
  const obras = useMemo(() => {
    const map = {};
    entries.forEach((e) => {
      const id = e.project_id || "none";
      (map[id] = map[id] || { id, name: e.project_name || "Sin obra", rows: [] }).rows.push(e);
    });
    return Object.values(map).sort((a, b) => a.name.localeCompare(b.name));
  }, [entries]);
  const [sel, setSel] = useState([]);
  useEffect(() => { if (open) setSel(obras.map((o) => o.id)); }, [open, obras]);

  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const total = obras.filter((o) => sel.includes(o.id)).reduce((acc, o) => acc + aggregate(o.rows).totalPagar, 0);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-sm" data-testid="obras-report-dialog">
        <DialogTitle className="font-heading flex items-center gap-2"><BarChart3 size={18} />Gasto de nómina por obra</DialogTitle>
        <DialogDescription>Selecciona las obras que quieres incluir en el reporte PDF de esta semana.</DialogDescription>
        <div className="flex gap-3 text-xs">
          <button className="text-blue-600 hover:underline" onClick={() => setSel(obras.map((o) => o.id))} data-testid="obras-select-all">Seleccionar todas</button>
          <button className="text-slate-500 hover:underline" onClick={() => setSel([])} data-testid="obras-select-none">Quitar todas</button>
        </div>
        <div className="max-h-72 overflow-auto border border-slate-200 rounded-sm divide-y divide-slate-100">
          {obras.length === 0 && <p className="p-3 text-sm text-slate-400">No hay trabajadores en esta semana.</p>}
          {obras.map((o) => (
            <label key={o.id} className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-slate-50" data-testid={`obra-option-${o.id}`}>
              <Checkbox checked={sel.includes(o.id)} onCheckedChange={() => toggle(o.id)} data-testid={`obra-check-${o.id}`} />
              <span className="flex-1 text-sm font-medium">{o.name}</span>
              <span className="text-xs text-slate-500">{o.rows.length} trab.</span>
              <span className="text-sm font-mono-data w-28 text-right">{money(aggregate(o.rows).totalPagar)}</span>
            </label>
          ))}
        </div>
        <div className="flex items-center justify-between pt-1">
          <span className="text-sm">Total seleccionado: <b data-testid="obras-report-total">{money(total)}</b></span>
          <Button disabled={!sel.length} onClick={() => onDownload(sel)} data-testid="obras-report-download" className="bg-slate-900 hover:bg-slate-800">Descargar PDF</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
